/* 
 * Convenience component to fetch ledger summary information for an account, calling
 * the getaccountledgersummary db function.  This returns:
 * - assetBalance:          Asset balance for the account - generally usable funds
 * - payInAr:               Inbound payments (e.g. topup) that haven't cleared yet
 * - assetAndFullArBalance: Assets (assetBalance) plus payInAr
 * - payInArAvailable:      Portion of inbound payments that we'll credit to be available for subscription purchases
 * - assetAndArBalance:     Assets (assetBalance) plus the portion of inbound payments 
 *                          that haven't cleared that we'll make available for subscription purchases (payInArAvailable)
 * - assetArAuthBalance:    Assets and credited ar (assetAndArBalance) less any outstanding auths (authBalance)
 * - balanceForTopupCalc:   Balance to be used for topup calculations.  This is assetArAuthBalance, except this can be
 *                          negative.  (assetArAuthBalance is returned as 0 if negative)
 * - liabilityBalance:      Any owed-to balances
 * - equityBalance:         Total equity - what we'll show as the balance for the account
 * - maxPayoutBalance:      Maximum payout - this will be cleared assets less liabilities and outstanding auth
 * - authBalance:           Outstanding auths
 * - floatBalanceDisplay:   Float balance for display purposes (minimum 0)
 * - floatBalanceForAuth:   Float balance (negative when there is a positive equity balance)
 */
import { fetchQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query AccountLedgerSummaryFetchQuery($accountId: UUID!) {
  getaccountledgersummary(accountId: $accountId, balancedate: null) {
    assetBalance
    payInAr
    assetAndFullArBalance
    payInArAvailable
    assetAndArBalance
    assetArAuthBalance
    balanceForTopupCalc
    liabilityBalance
    equityBalance
    maxPayoutBalance
    authBalance
    floatBalanceDisplay
    floatBalanceForAuth
  }
}
`;

function fetch(acctId) {
  const variables = {
    accountId: acctId
  }
  
  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

